import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import{ createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { allReducers } from './reducers';
import { sessionActions } from './actions/user/sessionActions';
import { startViewTracking } from './controller/viewTracker';

const store = createStore(allReducers,applyMiddleware(thunk));
sessionActions.setupSessionExpiryInterceptor(store);
startViewTracking();

const container = document.getElementById('root');
const root = createRoot(container)
root.render(
<Provider store={store}>
  <App />
</Provider>)

// ReactDOM.render(
//   <Provider store={store}>
//       <App />
//     </Provider>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
